import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseLabel} from '../../../../../utils/entity/course';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program} = contexts;

  const isIndividual = !!course?.client_id;

  const courseLabel = getCourseLabel(course);

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:course_created.title.individual')
       * t('notifications:course_created.title.group')
       * t('notifications:course_pending.title.individual')
       * t('notifications:course_pending.title.group')
       * t('notifications:course_started.title.individual')
       * t('notifications:course_started.title.group')
       */
      i18n.t(
        `notifications:${event.type}.title.${
          isIndividual ? 'individual' : 'group'
        }`,
        {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: program?.title,
        },
      ),
  };
};
